export default __webpack_public_path__ + "static/resource_hero_img-419f8317e9167efa5a3b754b18d1ebc8.jpg";